import { render, staticRenderFns } from "./AgentSettlementFinderAndCreator.vue?vue&type=template&id=13c97e40&"
import script from "./AgentSettlementFinderAndCreator.vue?vue&type=script&lang=js&"
export * from "./AgentSettlementFinderAndCreator.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports